var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKantanIcon = function SvgKantanIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.4 13.233h9.2a.6.6 0 0 1 .6.6v1.2c0 2.87-2.33 5.2-5.2 5.2s-5.2-2.33-5.2-5.2v-1.2a.6.6 0 0 1 .6-.6M12 10.767a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
  }))));
};
export default SvgKantanIcon;